import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import Monitoring24JamIcuSvc from "@/services/Monitoring24JamIcu";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "monitoring-24jam-icu"
})
class Monitoring24JamIcuModule extends VuexModule {
  list: any[] = [];
  current: any = null;
  currentDate: string | null = null;
  loading = false;

  @Mutation SET_LIST(val: any[]) {
    this.list = val;
  }

  @Mutation SET_CURRENT(val: any) {
    this.current = val;
  }

  @Mutation SET_CURRENT_DATE(val: string | null) {
    this.currentDate = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await Monitoring24JamIcuSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_LIST(data || []);
    } catch {
      this.SET_LIST([]);
    }
    this.SET_LOADING(false);
  }

  @Action async fetchByDate(payload: {
    reg: string | number;
    tanggal: string;
  }) {
    this.SET_LOADING(true);
    this.SET_CURRENT_DATE(payload.tanggal);
    try {
      const dt = await Monitoring24JamIcuSvc.getByRegisterAndDate(
        payload.reg,
        payload.tanggal
      );
      const { data } = dt.data;
      this.SET_CURRENT(data || null);
    } catch {
      this.SET_CURRENT(null);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await Monitoring24JamIcuSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT(data || null);
    } catch {
      this.SET_CURRENT(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_LIST([]);
    this.SET_CURRENT(null);
    this.SET_CURRENT_DATE(null);
  }
}

export const storeMonitoring24JamIcu = getModule(Monitoring24JamIcuModule);
